import * as actions from './qua-full-loading-list.actions';
import * as i18nInterface from 'src/app/shared/_config/i18n/i18n-interface';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, from } from 'rxjs';
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators';

import { ApiQuaMethod } from 'src/app/api/api-methods.qua';
import { Injectable, inject } from '@angular/core';
import { QuaLoadingListI } from 'src/app/api/qua-loading-list/qua-loading-list.result.int';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { TranslateService } from '@ngx-translate/core';
import { loadingQuaFullLoadingList } from 'src/app/shared/_config/i18n/i18n-interface';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';
import { spxToasterActions } from '@softpak/components/spx-toaster';

@Injectable()
export class QuaFullLoadingListEffects {
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);
    private readonly translateService = inject(TranslateService);

    load$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(action => from(this.sharedGenericService.invoke(ApiQuaMethod.quaLoadingList, action.query))
            .pipe(
                map((result: QuaLoadingListI) => result.containers.length > 0 ? actions.received({
                    result,
                }) : actions.error({
                    messageText: this.translateService.instant(i18nInterface.textErrorNoResultsFound)
                })),
                takeUntil(this.actions$.pipe(ofType(actions.load))),
                catchError((error) => {
                    console.error(error);
                    return [
                        actions.error({
                            messageText: error,
                        }),
                        spxToasterActions.createError({
                            autoClose: error.autoclose ? 5000 : undefined,
                            messageText: `${error?.title ? `${error?.title}: ` : ``} ${error.message}`,
                        }),
                    ];
                })
            )))
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(() => ([
            spxSpinnerActions.show({
                action: loadingQuaFullLoadingList
            }),
        ]))
    ));

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(() => ([
            spxSpinnerActions.hide({
                action: loadingQuaFullLoadingList
            }),
        ]))
    ));

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.received),
        mergeMap(() => ([
            spxSpinnerActions.hide({
                action: loadingQuaFullLoadingList
            }),
        ]))
    ));
}
